import '../scss/index.scss';
import * as bootstrap from 'bootstrap';

const LG_BREAKPOINT = 992;
const MD_BREAKPOINT = 768;
const SM_BREAKPOINT = 576;
const MD_HEADER_HEIGHT = 212;
const SM_HEADER_HEIGHT = 65; // With borders
const MD_MAIN_MARGIN_TOP = 98;
const SM_MAIN_MARGIN_TOP = 65;
const TIMEOUT = 300;
var updatingNavigationBar = false;

var prevScrollPosition = window.scrollY;

const toggleNavigationBar = () => {
  var currentScrollPosition = window.scrollY;
  const navBarElement = document.getElementById('header-nav');

  if (prevScrollPosition > currentScrollPosition) {
    showNavigationBar(navBarElement);
  } else {
    hideNavigationBar(navBarElement);
  }

  prevScrollPosition = currentScrollPosition;
  updatingNavigationBar = false;
};

const showNavigationBar = (navBarElement) => {
  navBarElement.style.top = 0;
  document.getElementById('content').classList.add('has-header');
};

const hideNavigationBar = (navBarElement) => {
  const screenWidth = screen.width;
  var adjustmentHeight =
    screenWidth >= MD_BREAKPOINT ? MD_HEADER_HEIGHT : SM_HEADER_HEIGHT;

  navBarElement.style.top = `-${adjustmentHeight}px`;
  document.getElementById('content').classList.remove('has-header');
};

const focusSearchInput = () => {
  document
    .getElementById('searchModal')
    .addEventListener('shown.bs.modal', (event) => {
      const searchInput = document.getElementById('search-term');
      if (searchInput) searchInput.focus({ focusVisible: true });
    });
};

window.addEventListener('resize', () => {
  const navBarElement = document.getElementById('header-nav');
  if (navBarElement) showNavigationBar(navBarElement);
});

window.addEventListener(
  'scroll',
  () => {
    if (!updatingNavigationBar) requestAnimationFrame(toggleNavigationBar);
    updatingNavigationBar = true;
  },
  false
);

window.addEventListener('load', () => {
  focusSearchInput();
});
